import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PublicLayout({ children, title }) {
  useEffect(() => {
    if (title) document.title = `${title} — Science + Consciousness Alliance`;
    else document.title = "Science + Consciousness Alliance — Expanding Science. Awakening Consciousness.";
  }, [title]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Header />
      <main className="pt-16 md:pt-20 lg:pt-[88px] bg-[#F8F6F1] text-[#050B14]">{children}</main>
      <Footer />
    </>
  );
}
